// ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react'
import { themes } from '../themes'
import useAuth from '../hooks/useAuth'
import { usesCoverAndCare } from '../config/schoolOverrides'

const ThemeContext = createContext()

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(themes.default)
  const { mainDpt, auth } = useAuth()

  useEffect(() => {
    getTheme()
  }, [mainDpt, auth.user, auth.schools])

  const getTheme = () => {
    const { hostname } = window.location
    let link = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    let selectedTheme = themes.default
    document.title = 'Schools Advisory Service - School Portal'
    link.href = '/sas_favicon.ico'
    // Prefer the current session over storage left behind by another school.
    let storedOrgId
    try {
      storedOrgId = JSON.parse(localStorage.getItem('orgType'))?.id
    } catch {
      storedOrgId = undefined
    }
    const schoolId = auth.schools?.[0]?.id ?? storedOrgId
    if (auth.user && usesCoverAndCare(schoolId)) {
      selectedTheme = themes.coverAndCare
      document.title = 'Cover and Care - School Portal'
      link.href = '/cc_favicon.ico'
    } else if (
      // hostname.includes('localhost') ||
      mainDpt === 'SAS' ||
      mainDpt === 'AIS' ||
      mainDpt === 'NAHT'
    ) {
      selectedTheme = themes.default
      document.title = 'Schools Advisory Service - School Portal'
      link.href = '/sas_favicon.ico'
    } else if (
      hostname.endsWith('.schoolsmutual.co.uk') ||
      mainDpt === 'Mutual' ||
      mainDpt === 'GBS'
    ) {
      document.title = 'Schools Mutual - School Portal'
      selectedTheme = themes.schoolsMutual // Wildcard domain check
      link.href = '/mutual_favicon.ico'
    } else if (hostname.endsWith('.cc-itl.com') || mainDpt === 'CC') {
      document.title = 'Cover and Care - School Portal'
      selectedTheme = themes.coverAndCare // Wildcard domain check
      link.href = '/cc_favicon.ico'
    }
    else if (hostname.endsWith('.sovriskmanagement.co.uk') || mainDpt === 'SRM') {
      document.title = 'Sovereign Risk Management - School Portal'
      selectedTheme = themes.sovriskManagement // Wildcard domain check
      link.href = '/srm-favicon.ico'
    }

    setTheme(selectedTheme)
  }

  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
}

export const useTheme = () => useContext(ThemeContext)
